import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import Button from 'components/Button/index'
import { Tabs } from 'antd'
import Avatar from 'components/Avatar'
export const SectionWrapper = styled(Flex)`
  width: 100%;
  height: calc(100vh - 142px);
  border: 1px solid ${COLORS.PAGE_BORDER};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  border-radius: 10px;
  overflow: scroll;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: '';
  }
`

export const TopHeader = styled(Flex)`
  padding: 20px 25px;
  position: relative;
  width: 100%;
  background: ${COLORS.BLUE_T_95};
  height: 131px;
`
export const RoleSpan = styled.span`
  font-size: 12px;
  color: ${COLORS.PRIMARY};
  padding-left: 15px;
  &:hover {
    cursor: pointer;
  }
`
export const JobDetailsSpan = styled.span`
  font-size: 12px;
  color: ${COLORS.GREY_T_60};
  padding-left: 10px;
`
export const RolesAvatar = styled(Avatar)`
  border-radius: 10px !important;
`
export const RolesHeaderDiv = styled.div`
  margin: 10px 0 0 18px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
`
export const AcceptButton = styled(Button.Primary)`
  border-radius: 10px;
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
`
export const AcceptAndSaveFlex = styled(Flex)`
  padding-top: 25px;
`
export const HeartIconSpan = styled.span`
  padding-right: 1.125rem;
  padding-top: 0.5rem;
  cursor: pointer;
`
export const LeftArrowSpan = styled.span`
  cursor: pointer;
`
export const TopRoleSection = styled(Flex)`
  align-items: center;
  margin-bottom: 2rem;
`
export const RoleInfoFlex = styled(Flex)`
  background: ${COLORS.WHITE};
`
export const JobDetailsTab = styled(Tabs)`
  .ant-tabs-nav::before {
    border-bottom: none;
  }
  .ant-tabs-nav {
    margin: 0 0 1rem 6.875rem;
  }
  .ant-tabs-tab-btn {
    color: #b4b5b6;
    text-shadow: 0 0 0.25px currentcolor;
  }
  .ant-tabs-ink-bar {
    background: #735cff;
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #5f6264;
  }
  padding: 1.25rem 1.562rem;
  width: 100%;
`
export const SubBold = styled.span`
  font-weight: bold;
  color: #343e59;
`

export const Container1 = styled.div`
  height: ${props => (props.expanded ? 'auto' : '250px')};

  overflow: hidden;
  overflow-wrap: break-word;
`

export const Content = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #808697;
`

export const ExtraPadding = styled.div`
  padding-bottom: 8px;
`

export const ShowMoreText = styled.span`
  cursor: pointer;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  color: #000;
  display: ${props => (props.visible ? 'inline-block' : 'none')};
  border-radius: 10px;
  background-color: #f0f2f4;
  font-weight: bold;
`

export const JobDetailsTabPane = styled(Tabs.TabPane)``
